<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container">
      <RuleBtn type="4" />
      <div class="mint-box">
        <div class="title">
          <span>{{ $t('mintpage.text1') }}</span>
        </div>
        <!-- <div class="img-box"></div> -->
        <avatar ref="avatar"></avatar>
        <mt-navbar v-model="selected" class="sm">
          <mt-tab-item id="1">{{ $t('mintpage.text2') }}</mt-tab-item>
          <!-- <mt-tab-item id="2">{{ $t('mintpage.text3') }}</mt-tab-item> -->
          <mt-tab-item id="3">{{ $t('mintpage.text4') }}</mt-tab-item>
          <mt-tab-item id="4">{{ $t('mintpage.text5') }}</mt-tab-item>
          <mt-tab-item id="5">{{ $t('mintpage.text6') }}</mt-tab-item>
          <!-- <mt-tab-item id="6">trousers</mt-tab-item> -->
        </mt-navbar>
        <!-- tab-container -->
        <div class="select-wrapper">
          <mt-tab-container v-model="selected">
            <mt-tab-container-item id="1">
              <div class="select-box">
                <div class="box box1">
                  <div
                    class="item"
                    v-for="(item, index) in imgData.nation"
                    :key="index"
                    @click="$refs.avatar.changeNation(index)">
                    <div
                      class="img"
                      :style="{
                        backgroundImage:
                          'url(' + $store.state.imgUrl + item['icon'] + ')'
                      }"></div>
                    <div class="text">{{ item.text }}</div>
                  </div>
                </div>
              </div>
            </mt-tab-container-item>
            <!-- <mt-tab-container-item id="2">
              <div class="select-box">
                <div class="box box1">
                  <div
                    class="item"
                    v-for="(item, index) in imgData.body"
                    :key="index"
                    @click="$refs.avatar.changeBody(index)">
                    <div
                      class="img"
                      :style="{
                        backgroundImage:
                          'url(' + $store.state.imgUrl + item['icon'] + ')'
                      }"></div>
                    <div class="text">{{ item.text }}</div>
                  </div>
                </div>
              </div>
            </mt-tab-container-item> -->
            <mt-tab-container-item id="3">
              <div class="select-box">
                <div class="box box1">
                  <div
                    class="item"
                    v-for="(item, index) in imgData.hair"
                    :key="index"
                    @click="$refs.avatar.changeHair(index)">
                    <div
                      class="img"
                      :style="{
                        backgroundImage:
                          'url(' + $store.state.imgUrl + item['icon'] + ')'
                      }"></div>
                    <div class="text">{{ item.text }}</div>
                  </div>
                </div>
              </div>
            </mt-tab-container-item>
            <mt-tab-container-item id="4">
              <div class="select-box">
                <div class="box box1">
                  <div
                    class="item"
                    v-for="(item, index) in imgData.eyes"
                    :key="index"
                    @click="$refs.avatar.changeEyes(index)">
                    <div
                      class="img"
                      :style="{
                        backgroundImage:
                          'url(' + $store.state.imgUrl + item['icon'] + ')'
                      }"></div>
                    <div class="text">{{ item.text }}</div>
                  </div>
                </div>
              </div>
            </mt-tab-container-item>
            <mt-tab-container-item id="5">
              <div class="select-box">
                <div class="box box1">
                  <div
                    class="item"
                    v-for="(item, index) in imgData.mouth"
                    :key="index"
                    @click="$refs.avatar.changeMouth(index)">
                    <div
                      class="img"
                      :style="{
                        backgroundImage:
                          'url(' + $store.state.imgUrl + item['icon'] + ')'
                      }"></div>
                    <div class="text">{{ item.text }}</div>
                  </div>
                </div>
              </div>
            </mt-tab-container-item>
            <!-- <mt-tab-container-item id="6">
              <div class="select-box">
                <div class="box box1">
                  <div
                    class="item"
                    v-for="(item, index) in imgData.pants"
                    :key="index"
                    @click="$refs.avatar.changePants(index)">
                    <div
                      class="img"
                      :style="{
                        backgroundImage:
                          'url(' + $store.state.imgUrl + item['icon'] + ')'
                      }"></div>
                    <div class="text">{{ item.text }}</div>
                  </div>
                </div>
              </div>
            </mt-tab-container-item> -->
          </mt-tab-container>
          <div class="select-btn">
            <el-button
              class="el-button--special2 block round"
              @click="handleRoute('UserMintConfirm')"
              >{{ $t('next') }}</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserAvatarList } from '@/api/avatar'
import RuleBtn from '@/components/RuleBtn.vue'

import Avatar from '../../components/Avatar.vue'

export default {
  name: 'UserMint',
  components: {
    Avatar,
    RuleBtn
  },
  data() {
    return {
      selected: '1',
      avatar: require('@/assets/images/babe.svg'),
      imgData: {}
    }
  },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.$route.params.imgData) {
        getUserAvatarList().then((res) => {
          // this.img = getAvatarListMock();
          console.log(res.data)
          this.$refs.avatar.initData(res.data)
          // this.$refs.avatar.setAvatarList(getAvatarListMock())
          this.imgData = res.data
        })
      } else {
        this.imgData = this.$route.params.imgData
        this.$refs.avatar.initData(
          this.$route.params.imgData,
          this.$route.params.selectIndexs
        )
      }
    },
    handleRoute(path) {
      let params = {
        selectIndexs: this.$refs.avatar.selectIndexs,
        imgData: this.imgData
      }
      localStorage.setItem('mintinfo', JSON.stringify(params))
      this.$router.push({
        name: path
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.select-wrapper {
  .mint-tab-container-item {
    height: 1.8rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .select-btn {
    padding: 0.1rem 0.74rem;
    .el-button.block {
      font-size: 0.14rem;
    }
  }
  .select-box {
    overflow-x: scroll;
    padding: 0 0 0.1rem 0;
    .box {
      display: flex;
      &.box1 {
        .item {
          margin-right: 0.1rem;
          .img {
            width: 0.82rem;
            height: 0.82rem;
            border: 1px solid #e3e3e3;
            background-size: cover;
          }
          .text {
            font-size: 0.14rem;
            margin-top: 0.1rem;
            font-family: 'Montserrat';
          }
        }
      }
      &.box2 {
        .item {
          width: 0.36rem;
          height: 0.36rem;
          border-radius: 1rem;
          border: 2px solid #ffffff;
          margin-right: 0.18rem;
          flex: 0 0 0.36rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/mint.vue